//需要持久化的数据都存在这
const state = {
    dirverHead: [], //表头类别
    listAdd: [], //已显示的列
    listDel: [], //未显示的列
    dirverHead2: [], //表头类别
    listAdd2: [], //已显示的列
    listDel2: [], //未显示的列
    paymentm: {
        dirverHead: [], //司机支付的表头信息
        listAdd: [], //已显示的列
        listDel: [], //未显示的列
    },
    paymentTwo: {
        driverHead: [], //司机支付2.0的表头信息
        listAdd: [], //已显示的列
        listDel: [], //未显示的列
    },
    //运单管理
    waybillHead: [], //表头类别
    listAdd3: [], //已显示的列
    listDel3: [], //未显示的列
    driverHeadSettleTwo: [], //司机结算2.0表头类别
    listAdd4: [], //已显示的列
    listDel4: [], //未显示的列

};

//getters
const getters = {

};

const mutations = {
    getDirverHead(state, dirverHead) {
        state.dirverHead = dirverHead
    },
    chooseList(state, listAll) {
        state.listAdd = listAll.listAdd;
        state.listDel = listAll.listDel
    },
    getDirverHead2(state, dirverHead) {
        state.dirverHead2 = dirverHead
    },
    chooseList2(state, listAll) {
        state.listAdd2 = listAll.listAdd;
        state.listDel2 = listAll.listDel
    },
    getPmDirverHead(state, dirverHead) {
        //司机支付的表头信息
        state.dirverHead = dirverHead;
    },
    getPmTwoDriverHead(state, driverHead) {
        //司机支付2.0的表头信息
        state.paymentTwo.driverHead = driverHead;
    },
    pmChooseList(state, listAll) {
        //司机支付筛选已显示未显示的列
        state.listAdd = listAll.listAdd;
        state.listDel = listAll.listDel;
    },
    //运单管理
    getDirverHead3(state, dirverHead) {
        state.waybillHead = dirverHead
    },
    chooseList3(state, listAll) {
        state.chooseList3 = listAll.listAll;
        state.listDel3 = listAll.listDel
    },
    clearAdd3(state, listAll) {
        state.listAdd3 = listAll;
    },
    //司机结算2.0中的表头管理
    getDirverHead4(state, dirverHead) {
        state.driverHeadSettleTwo = dirverHead
    },
    chooseList4(state, listAll) {
        state.listAdd4 = listAll.listAdd;
        state.listDel4 = listAll.listDel
    },
};
// actions
const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/persist.js